var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSbp = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 21 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.666 4.677v2.934H19.62V5.553h-1.01v2.058h-1.047V4.677z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.411 7.716c.938 0 1.634-.575 1.634-1.447 0-.843-.514-1.391-1.372-1.391-.397 0-.724.14-.97.38a.97.97 0 0 1 .943-.86l.912-.002.455-.871s-1.01.023-1.48.023c-1.074.019-1.799.994-1.799 2.179 0 1.38.707 1.99 1.677 1.99m.006-2.067c.348 0 .59.23.59.62 0 .353-.215.643-.59.643-.36 0-.6-.268-.6-.637 0-.39.24-.626.6-.626",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.882 6.629s-.248.143-.617.17c-.425.012-.804-.256-.804-.733 0-.465.335-.731.793-.731.281 0 .653.195.653.195s.273-.5.413-.75c-.258-.195-.602-.303-1.002-.303-1.01 0-1.791.658-1.791 1.583 0 .937.735 1.58 1.791 1.56.296-.01.703-.114.951-.274z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#5b57a2",
  d: "M0 2.612 1.453 5.21v1.584L.002 9.386z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#d90751",
  d: "m5.58 4.264 1.36-.834 2.787-.003L5.58 5.968z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fab718",
  d: "m5.572 2.597.008 3.439-1.457-.895V0z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#ed6f26",
  d: "m9.728 3.427-2.787.003-1.369-.833L4.123 0z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#63b22f",
  d: "M5.58 9.4V7.733l-1.457-.878V12z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#1487c9",
  d: "M6.938 8.574 1.453 5.21 0 2.612 9.722 8.57z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#017f36",
  d: "M4.124 12 5.58 9.4l1.358-.826 2.784-.004z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#984995",
  d: "m.002 9.386 4.133-2.532-1.39-.852-1.292.792z"
})));
export default SvgSbp;